"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _link = _interopRequireDefault(require("../../core/link"));
var _navTabs = _interopRequireDefault(require("../../core/nav-tabs"));
var _pagerButton = _interopRequireDefault(require("../../core/pager-button"));
var _myButton = _interopRequireDefault(require("./my-button"));
var _myEntries = _interopRequireDefault(require("./my-entries"));
var _myPayments = _interopRequireDefault(require("./my-payments"));
var _notFound = _interopRequireDefault(require("../../not-found"));
var _requireAuthentication = _interopRequireDefault(require("../../require-authentication"));
var _constantParams = require("../../../constant-params");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement(_myButton.default, null);
var _ref2 = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function MyAccount({
  loaded,
  match: {
    url,
    path,
    params
  }
}) {
  const previousYear = +params.yearID - 1;
  const previousYearURL = `/year/${previousYear}/my-account`;
  const nextYear = +params.yearID + 1;
  const nextYearURL = `/year/${nextYear}/my-account`;
  return /*#__PURE__*/_react.default.createElement("div", null, previousYear < 2016 ? null : /*#__PURE__*/_react.default.createElement("span", {
    className: "pull-xs-left"
  }, /*#__PURE__*/_react.default.createElement(_pagerButton.default, {
    to: previousYearURL
  }, "Previous Year (", previousYear, ")")), /*#__PURE__*/_react.default.createElement("div", {
    className: "pull-xs-right"
  }, nextYear > _constantParams.thisYear + 1 ? null : /*#__PURE__*/_react.default.createElement(_pagerButton.default, {
    to: nextYearURL
  }, "Next Year ", nextYear)), /*#__PURE__*/_react.default.createElement("h1", {
    className: "text-primary text-xs-center"
  }, params.yearID), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginBottom: 14
    }
  }, _ref), /*#__PURE__*/_react.default.createElement(_navTabs.default, null, /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/my-entries'
  }, "Entries")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/my-payments'
  }, "Payments"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 14
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: path,
    to: url + '/my-entries'
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/my-entries',
    component: _myEntries.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/my-payments',
    component: _myPayments.default
  }), ")", _ref2)));
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = (0, _requireAuthentication.default)(MyAccount);